export type ModalWidth = 'large' | 'medium' | 'small' | number;

export const modalWidths: Record<Exclude<ModalWidth, number>, number> = {
  large: 800,
  medium: 640,
  small: 480,
};
